export const BUTTON = "MGButton";
export const ICONBUTTON = "MGIconButton";
